import { fromJS, Map } from 'immutable';
import * as actions from '../actions/global';
import * as userActions from '../actions/user';

const initialStats = {
  configuration: {},
  user: {},
  userStatus: {},
  isSidebarVisible: true,
  isPageMenuVisible: false,
  isRecordingStart: false,
  offices: [],
  users: [],
  lastRecalcStatus: {},
  routeState: new Map(),
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    // User actions
    // ////////////
    case userActions.LOGIN_SUCCESS:
      return state.set('user', fromJS(action.data.user));

    // Global actions
    // //////////////
    case actions.RECORD_START:
      return state.set('isRecordingStart', true);

    case actions.RECORD_STOP:
      return state.set('isRecordingStart', false);

    case actions.TOGGLE_SIDEBAR:
      const newState = state.set('isPageMenuVisible', false);
      return newState.set('isSidebarVisible', !state.get('isSidebarVisible'));
    case actions.TOGGLE_PAGE_MENU:
      return state.set('isPageMenuVisible', !state.get('isPageMenuVisible'));
    case actions.CONFIGURE:
      return state.mergeIn(['configuration'], fromJS(action.configuration));

    case actions.OFFICES_FETCH_SUCCESS:
      return state.set(
        'offices',
        fromJS(action.data ? action.data.results : []),
      );

    case actions.LAST_RECALC_STATUS_FETCH_SUCCESS:
      return state.set(
        'lastRecalcStatus',
        fromJS(
          action.data && action.data.results ? action.data.results[0] : {},
        ),
      );

    case actions.USERS_FETCH_SUCCESS:
      return state.set('users', fromJS(action.data ? action.data.results : []));

    case actions.FETCH_USER_STATUS_SUCCESS:
    case actions.UPDATE_USER_STATUS:
      const prevUserStatus = state.get('userStatus').toJS();
      if (
        action.data &&
        action.data.results &&
        (prevUserStatus.forceLogOff !== action.data.results[0].forceLogOff ||
          prevUserStatus.readOnly !== action.data.results[0].readOnly)
      ) {
        return state.set(
          'userStatus',
          fromJS(
            action.data && action.data.results ? action.data.results[0] : {},
          ),
        );
      }
      return state;
    case actions.SET_ROUTE_STATE: {
      const routeState = state.getIn(['routeState']);
      return state.setIn(
        ['routeState'],
        new Map(routeState).set(action.key, {
          ...routeState.get(action.key),
          routeState: action.state,
        }),
      );
    }
    case actions.RESET_ROUTE_STATE: {
      const routeState = state.getIn(['routeState']);
      return state.setIn(
        ['routeState'],
        new Map(routeState).set(action.key, {
          ...routeState.get(action.key),
          routeState: action.state ? action.state : {},
        }),
      );
    }

    default:
      return state;
  }
};
